module.exports = __webpack_public_path__ + "img/logo-company.0d77f574.png";